import type { NavigationMenuItem } from '#ui/types';
import type { ComputedRef } from 'vue';

import { ROUTE_NAMES } from '~/constants/routes';

export const useAccountMenuItems = (): ComputedRef<NavigationMenuItem[][]> => {
    const localePath = useLocalePath();
    const { tt } = useTypedI18n();
    const { trackAccountBids, trackAccountSales, trackAccountSoldVehicles, trackAccountYourOrdersInDirectSales, trackAccountProfile } = useTracking();

    return computed<NavigationMenuItem[][]>(() => [
        [
            {
                label: tt('account.menu.buy'),
                type: 'label' as const,
            },
            {
                label: tt('account.favorites.title'),
                icon: 'lucide:bookmark-check',
                to: localePath(ROUTE_NAMES.ACCOUNT_FAVORITES),
            },
            {
                label: tt('account.bids.title'),
                icon: 'lucide:hourglass',
                to: localePath(ROUTE_NAMES.ACCOUNT_BIDS),
                onSelect: trackAccountBids,
            },
            {
                label: tt('account.negotiations.buyer.menuItem'),
                icon: 'lucide:handshake',
                to: localePath(ROUTE_NAMES.ACCOUNT_BUYER_NEGOTIATIONS),
            },
            {
                label: tt('account.orders.title'),
                icon: 'lucide:handbag',
                to: localePath(ROUTE_NAMES.ACCOUNT_ORDERS),
                onSelect: trackAccountYourOrdersInDirectSales,
            },
        ],
        [
            {
                label: tt('account.menu.sell'),
                type: 'label' as const,
            },
            {
                label: tt('account.vehiclesForSale.title'),
                icon: 'lucide:tag',
                to: localePath(ROUTE_NAMES.ACCOUNT_VEHICLES_FOR_SALE),
                onSelect: trackAccountSales,
            },
            {
                label: tt('account.negotiations.seller.menuItem'),
                icon: 'lucide:handshake',
                to: localePath(ROUTE_NAMES.ACCOUNT_SELLER_NEGOTIATIONS),
            },
            {
                label: tt('account.soldVehicles.title'),
                icon: 'lucide:badge-check',
                to: localePath(ROUTE_NAMES.ACCOUNT_SOLD_VEHICLES),
                onSelect: trackAccountSoldVehicles,
            },
        ],
        [
            {
                label: tt('profile.title'),
                icon: 'lucide:user',
                to: localePath(ROUTE_NAMES.ACCOUNT_PROFILE),
                onSelect: trackAccountProfile,
            },
        ],
    ]);
};
